import PropTypes from 'prop-types';
import React from 'react';
import { color, conditionColorMap } from '@surfline/quiver-themes';

const gradientOffsetX = 15;
const gradientOffsetY = 27 - Math.sqrt(24 * 24 - gradientOffsetX * gradientOffsetX);

const topGradientStartPoint = `${27 - gradientOffsetX},${gradientOffsetY}`;
const topGradientEndPoint = `${27 + gradientOffsetX},${gradientOffsetY}`;
const bottomGradientStartPoint = `${27 - gradientOffsetX},${54 - gradientOffsetY}`;
const bottomGradientEndPoint = `${27 + gradientOffsetX},${54 - gradientOffsetY}`;

const topGradientPath = `M${topGradientStartPoint} A24,24,0,0,1,${topGradientEndPoint}`;
const bottomGradientPath = `M${bottomGradientStartPoint} A24,24,0,0,0,${bottomGradientEndPoint}`;
const leftArcPath = `M${topGradientStartPoint} A24,24,0,0,0,${bottomGradientStartPoint}`;
const rightArcPath = `M${topGradientEndPoint} A24,24,0,0,1,${bottomGradientEndPoint}`;

const SpotClusterMarker = ({ spotCount, worstCondition, bestCondition, onClick }) => {
  const worstColor = conditionColorMap.has(worstCondition)
    ? conditionColorMap.get(worstCondition).default
    : color('white');
  const bestColor = conditionColorMap.has(bestCondition)
    ? conditionColorMap.get(bestCondition).default
    : color('white');

  // This is necessary to prevent the linearGradient defs from conflicting with each other
  const conditionsGradientId = `ConditionsGradient:${worstCondition}:${bestCondition}`;
  const conditionsGradientStroke = `url(#${conditionsGradientId})`;

  return (
    <svg className="sl-spot-cluster-marker" width="54px" height="54px" onClick={onClick}>
      <defs>
        <linearGradient id={conditionsGradientId}>
          <stop offset="0%" stopColor={worstColor} />
          <stop offset="100%" stopColor={bestColor} />
        </linearGradient>
      </defs>
      <g>
        <circle cx="27" cy="27" r="24" />
        <path d={leftArcPath} stroke={worstColor} />
        <path d={topGradientPath} stroke={conditionsGradientStroke} />
        <path d={rightArcPath} stroke={bestColor} />
        <path d={bottomGradientPath} stroke={conditionsGradientStroke} />
      </g>
      <text x="27" y="28.5">
        {spotCount}
      </text>
    </svg>
  );
};

SpotClusterMarker.propTypes = {
  worstCondition: PropTypes.string,
  bestCondition: PropTypes.string,
  spotCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

SpotClusterMarker.defaultProps = {
  worstCondition: null,
  bestCondition: null,
  onClick: () => null,
};

export default SpotClusterMarker;
